import { useZeroFoods } from "@animus/frontend-features/nutrition/foods";

import { FoodsBrowser } from "./foods-browser.tsx";

function FoodsBrowserConnected() {
  const { foods, isLoading, error } = useZeroFoods({ limit: 50 });

  return <FoodsBrowser error={error} foods={foods} isLoading={isLoading} />;
}

export { FoodsBrowserConnected };
